

























import { Component, Vue, } from "@/shared/vuepack";
import * as routes from "@/employer/route-names";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";
import { useUserStore } from "@/shared/store/user";

@Component({})
export default class MyProgramNavigation extends Vue {
  activeTab = null;
  routes = routes;
  userStore = useUserStore();
  partnerSettingStore = usePartnerSettingStore();
  mounted (): void {
    this.activeTab = this.$route.name;
    if (!this.partnerSettingStore.isLoaded) {
      this.partnerSettingStore.loadEmployerPartnerSettings({
        partnerId: this.userStore.currentEmployer.partnerId,
        employerId: this.userStore.currentEmployer.employerId
      });
    }
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }
}
